// Whether a solution card's member is dynamically nested, answered from what it is -- its uuid -- and not from the
// dynamic_nesting flag a stored card brings back from the browser (Frank::DynamicNesting.member?).
export const isDynamicNestingMember = (member) => String((member && member.uuid) || '').startsWith('LayoutPartNesting_');
